import type { ReactElement } from "react";
import {
  NOT_FOUND_ROUTE,
  PAGE_ROUTES,
  type RouteMetadata,
} from "@/routes/routeManifest";
import { routeElements } from "@/routes/routeElements";

export type AppRoute = RouteMetadata & {
  element: ReactElement;
};

export const APP_ROUTES: readonly AppRoute[] = PAGE_ROUTES.map((route) => ({
  ...route,
  element: routeElements[route.id],
}));

export const APP_NOT_FOUND_ROUTE: AppRoute = {
  ...NOT_FOUND_ROUTE,
  element: routeElements.notFound,
};
